import './ccf-dock-control-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDockControlIconProps extends SvgIconProps  {}

/**
 * Component displays dock control icon
 * @param props -CcfDockControlIconProps
 * @returns svg dock control icon
 * @example <CcfDockControlIcon/>
 */
export function CcfDockControlIcon(props: CcfDockControlIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Dock">
        <g
          id="Group_112088"
          data-name="Group 112088"
          transform="translate(-747 -126)"
        >
          <path
            id="Polygon_26"
            data-name="Polygon 26"
            d="M5,0l5,8.182H0Z"
            transform="translate(751 143) rotate(-90)"
            fill="#526b7a"
          />
          <g
            id="Group_112088-2"
            data-name="Group 112088"
            transform="translate(-105 71)"
          >
            <rect
              id="Rectangle_37860"
              data-name="Rectangle 37860"
              width="2"
              height="2"
              transform="translate(864 66)"
              fill="#526b7a"
            />
            <rect
              id="Rectangle_37861"
              data-name="Rectangle 37861"
              width="2"
              height="2"
              transform="translate(867 66)"
              fill="#526b7a"
            />
            <rect
              id="Rectangle_37872"
              data-name="Rectangle 37872"
              width="2"
              height="2"
              transform="translate(858 66)"
              fill="#526b7a"
            />
            <rect
              id="Rectangle_37862"
              data-name="Rectangle 37862"
              width="2"
              height="2"
              transform="translate(870 66)"
              fill="#526b7a"
            />
            <rect
              id="Rectangle_37873"
              data-name="Rectangle 37873"
              width="2"
              height="2"
              transform="translate(861 66)"
              fill="#526b7a"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDockControlIcon;
